import { Button } from '@/src/components/Commons/Button';
import LoaderButton from '@/src/components/Commons/LoaderButton/LoaderButton';
import { formatAddress } from '@/src/lib/SmartDB/Commons/formatters';
import { useAppStore } from '@/src/store/global';
import PriceToggle from '../PriceToggle/PriceToggle';
import { showADA_Amount_Rounded } from '@/src/store/global/tokensStoreModelHelpers';
import { TOKEN_ADA_SYMBOL } from '@/src/lib/SmartDB/Commons/Constants/constants';
import { CLOSE, DISCONNECT, EYE_HIDE, EYE_SHOW, PORTFOLIO, REPEAT } from '@/src/lib/SmartDB/Commons/Constants/images';
import Image from 'next/image';
import * as React from 'react';
import WalletInfo from '../../WalletInfo';
import useWalletActions from '../useWalletActions';
import styles from './WalletInfoModal.module.scss';
import { showADAPriceToggleButton } from '@/src/utils/constants';

interface WalletConnectorProps {
    isMobile?: boolean;
}

export default function WalletInfoModal(props: WalletConnectorProps) {
    //--------------------------------------
    const appStore = useAppStore();
    //--------------------------------------
    const [isOpen, setIsOpen] = React.useState(false);
    const handleOpen = () => setIsOpen(true);
    const handleClose = () => setIsOpen(false);
    //--------------------------------------
    const { isMobile } = props;
    //--------------------------------------
    const { isRefreshing, tokensStore, session, status, walletStore, walletRefresh, handleBtnPortfolio, walletDisconnect } = useWalletActions();
    //--------------------------------------
    function showWalletConnectedButtons() {
        return (
            <>
                <div
                    key={walletStore.info!.pkh + ' portfolio'}
                    className={styles.wallet}
                    onClick={async () => {
                        setIsOpen(false);
                        await handleBtnPortfolio();
                    }}
                >
                    <div className={styles.walletName}>
                        <p className={styles.text}>Portfolio</p>
                        <Image src={PORTFOLIO} alt={'Portfolio'} width={30} height={30}></Image>
                    </div>
                </div>

                <div key={walletStore.info!.pkh + ' disconnect'} className={styles.wallet} onClick={async () => await walletDisconnect(false)}>
                    <div className={styles.walletName}>
                        <p className={styles.text}>Disconnect Wallet</p>
                        <Image src={DISCONNECT} alt={'Disconnect'} width={30} height={30}></Image>
                    </div>
                </div>
            </>
        );
    }
    //--------------------------------------
    const handleToggleIsHide = () => {
        walletStore.setSwHideBalance(!walletStore.swHideBalance);
    };
    //--------------------------------------
    return (
        <>
            <Button mode="connect" size="small" onClick={handleOpen}>
                <>
                    {walletStore.swHideBalance === true ? `*** ${TOKEN_ADA_SYMBOL}` : `${showADA_Amount_Rounded(tokensStore, BigInt(walletStore.getTotalOfUnit('lovelace')))}`}
                    {' | '}
                    {showADAPriceToggleButton === true && (
                        <>
                            <PriceToggle compact={true} />
                            {' | '}
                        </>
                    )}
                    <div className={styles.hideBalance}>
                        <svg
                            width="19"
                            height="19"
                            className={styles.icon}
                            onClick={(event) => {
                                handleToggleIsHide();
                                event.stopPropagation();
                            }}
                        >
                            <use href={walletStore.swHideBalance === true ? EYE_HIDE : EYE_SHOW}></use>
                        </svg>
                    </div>
                    {' | '}
                    {walletStore.isConnected && walletStore.info ? formatAddress(walletStore.info.address) : null}
                    {' | '}
                    <div className={styles.refresh}>
                        {status === 'loading' || walletStore.isConnecting || walletStore.isLoadingAnyData ? (
                            <LoaderButton />
                        ) : (
                            <svg
                                width="14"
                                height="14"
                                id="icon"
                                className={styles.icon}
                                onClick={(event) => {
                                    event.stopPropagation();
                                    walletStore.loadWalletData({ swLoadParticipation: true, swLoadSwapOffers: true });
                                }}
                            >
                                <use href={REPEAT}></use>
                            </svg>
                        )}
                    </div>
                </>
            </Button>

            {isOpen === true ? (
                <div className={styles.modal}>
                    <div className={`${styles.main} ${styles.connectModal}`}>
                        <div className={styles.popUp}>
                            <header className={styles.headerModal}>
                                <h2 className={styles.titleModal}>
                                    <>YOUR WALLET [{walletStore.info!.walletName}]</>
                                </h2>
                                <svg width="45" height="45" className={styles.icon} onClick={handleClose}>
                                    <use href={CLOSE}></use>
                                </svg>
                            </header>
                            <div className={styles.walletContainer}>
                                <WalletInfo isForModal={true} />
                                <>{showWalletConnectedButtons()}</>
                            </div>
                        </div>
                    </div>
                </div>
            ) : null}
        </>
    );
}
